import { SuccessResponse } from "../../../node_modules/chaild-entity/src/common/response/response";

export const isTypeSuccessResponse = (arg): arg is SuccessResponse =>
  arg !== null && typeof arg === "object" && (arg as SuccessResponse).data;
